import { useParams } from "react-router-dom";
import React, { useState, useEffect } from 'react'
import { API, Auth } from 'aws-amplify';
import { Text, View, Flex, Divider} from '@aws-amplify/ui-react';
import Loadingmini from '../components/loadingmini';
import { Heading, Button } from '@aws-amplify/ui-react';

export default function Policy({paramPolicyId}) {
  let params = useParams();
  var tpolicyId = false

  if(paramPolicyId)
  {
    tpolicyId = paramPolicyId;
  } else {
    tpolicyId = params.policyId;
  }
  const [policyId, updatePolicyId] = React.useState(tpolicyId);
  const [policy, updatePolicy] = useState({status:"If this message stays - email us at info@joinago.com",rows:[]})
  const [is_loading, updateIsLoading] = React.useState(false);
  const [showDataPacket, updateShowDataPacket] = React.useState(false);
  const [jwt, setJwt] = React.useState(false);
  const [displayAdministrativeFunctions, updateDisplayAdministrativeFunctions] = React.useState(false);
  const [displaySuperAdministrativeFunctions, updateDisplaySuperAdministrativeFunctions] = React.useState(false);


  const fetchPageData = async () => {
    var thisPolicyId = policyId;
    if(paramPolicyId > 0)
    {
      thisPolicyId = paramPolicyId;
      updatePolicyId(paramPolicyId);
    }
    updateIsLoading(true)
    let session = await Auth.currentSession()      
    let accessToken = session.getAccessToken()
    if(accessToken.payload["cognito:groups"])
      {
          if(accessToken.payload["cognito:groups"][0]==='admin'||accessToken.payload["cognito:groups"][0]==='support'||accessToken.payload["cognito:groups"][0]==='fleet')
          {
              updateDisplayAdministrativeFunctions(true)
              if(accessToken.payload["cognito:groups"][0]==='admin')
              {
                  updateDisplaySuperAdministrativeFunctions(true)
              }
          }
      }
    var thisJwt = await accessToken.getJwtToken()
    setJwt(thisJwt)
    var initProps = { 
      back_end: process.env.REACT_APP_BACKEND, 
      api_endpoint: "api3:staff:insurance_policy",
      jwt:thisJwt,
      request_type:"GET",
      policy_id: thisPolicyId
    }
    const myInit = {queryStringParameters:initProps};
    //console.log(JSON.stringify('myInit: '+JSON.stringify(myInit))); //temp
    try {
      const res = await API.get('adminWebTools','/ago',myInit);
      console.log(JSON.stringify(res))
      updatePolicy(res);
      updateIsLoading(false)
      return
    }
    catch (e) {
        const res = {status:"Error retrieving Policy or User not permissioned - email us at info@joinago.com",rows:[]};
        updatePolicy(res);
        updateIsLoading(false)
        return
    }
  }

  useEffect(() => {
    fetchPageData()
  },[params,paramPolicyId])

  
  return (
    is_loading ? <Loadingmini /> : 
    <Flex //  https://ui.docs.amplify.aws/react/components/flex#demo
      direction="column"
    >
      <View style={{padding:"1rem"}}>
          <Flex>
            {
              policy === false ? <Heading level={1}>Policy #{policyId}</Heading> :
              policy['rows'] === false ? <Heading level={1}>Policy #{policyId}</Heading> :
              typeof(policy['rows']) === 'undefined' ?  <Heading level={1}>Policy #{policyId}</Heading> :
              policy['rows'][0] === false || policy['rows'][0] === null ? <Heading level={1}>Policy #{policyId}</Heading> :
              typeof(policy['rows'][0]) === 'undefined' ?  <Heading level={1}>Policy #{policyId}</Heading> :
              'policy_number' in policy['rows'][0] === false ? <Heading level={1}>Policy #{policyId}</Heading> :
              policy['rows'][0]["policy_number"] === "" ? <Heading level={1}>Policy #{policyId}</Heading> :
              <Heading level={1}>{policy['rows'][0]["policy_number"]}</Heading>
            }
          </Flex>
          <Flex direction="column">
              <Flex direction="row" wrap="wrap" justifyContent="flex-start" gap="1rem">
                <View>
                  <Button onClick={() => fetchPageData()}>
                      PRESS TO GET LATEST UPDATES
                  </Button>
                </View>
              </Flex>
          </Flex>
          <Divider />
          {
            jwt === false ? undefined :
            <Flex direction="column">
                <Flex wrap="wrap" justifyContent="center" gap="1rem">
                  {
                      policy === false ? <Heading level={1}>Loading...</Heading> :
                      policy['rows'] === false ? <Heading level={1}>Loading...</Heading> :
                      typeof(policy['rows']) === 'undefined' ?  <Heading level={1}>Loading...</Heading> :
                      policy['rows'][0] === false || policy['rows'][0] === null ? <Heading level={1}>Loading...</Heading> :
                      typeof(policy['rows'][0]) === 'undefined' ?  <Heading level={1}>Loading...</Heading> :
                      'policy_number' in policy['rows'][0] === false ? <Heading level={1}>Loading...</Heading> :
                      policy['rows'][0]["policy_number"] === "" ? <Heading level={1}>Loading...</Heading> :
                      policy['rows'][0] ?
                      <View>
                        <Divider />
                        <table>
                          <tr>
                            <td>Policy ID:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['id']}</td>
                          </tr>
                          <tr>
                            <td>Policy Number:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['policy_number']}</td>
                          </tr>
                          <tr>
                            <td>Created:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['sql_timestamp']}</td>
                          </tr>
                          <tr>
                            <td>Effective Date:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['effective_date']}</td>
                          </tr>
                          <tr>
                            <td>End Date:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['end_date']}</td>
                          </tr>
                          <tr>
                            <td>Fleet:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['fleet_code']}</td>
                          </tr>
                          <tr>
                            <td>Company:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['company']}</td>
                          </tr>
                          <tr>
                            <td>Fronting Company:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['fronting_company_name']}</td>
                          </tr>
                          <tr>
                            <td>Fronting Company Type:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['fronting_company_type']}</td>
                          </tr>
                          <tr>
                            <td>Fronting Company Address:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['fronting_company_address']}</td>
                          </tr>
                          <tr>
                            <td>Issuing Company:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['issuing_company_name']}</td>
                          </tr>
                          <tr>
                            <td>Issuing Company Type:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['issuing_company_type']}</td>
                          </tr>
                          <tr>
                            <td>Issuing Company Address:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['issuing_company_address']}</td>
                          </tr>
                          <tr>
                            <td>Insuring Company:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['insuring_company_name']}</td>
                          </tr>
                          <tr>
                            <td>Insuring Company Type:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['insuring_company_type']}</td>
                          </tr>
                          <tr>
                            <td>Insuring Company Address:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['insuring_company_address']}</td>
                          </tr>
                          <tr>
                            <td>Policy States:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['insurance_policy_state']}</td>
                          </tr>
                          <tr>
                            <td>Is Active:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['is_active']}</td>
                          </tr>
                          <tr>
                            <td>Requires Onboarding:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['requires_onboarding']}</td>
                          </tr>
                          <tr>
                            <td>Onboarding Emails:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['onboarding_emails']}</td>
                          </tr>
                          <tr>
                            <td>Minimum Age:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['min_age']}</td>
                          </tr>
                          <tr>
                            <td>Coverage:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['coverage']}</td>
                          </tr>
                          <tr>
                            <td>Period 1 Before Mins:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['p1_before_mins']}</td>
                          </tr>
                          <tr>
                            <td>Period 1 After Mins:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['p1_after_mins']}</td>
                          </tr>
                          <tr>
                            <td>Monthly Billing Date:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['monthly_billing_date']}</td>
                          </tr>
                          <tr>
                            <td>Liability Cents per Mile:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['liability_cents_per_mile']}</td>
                          </tr>
                          <tr>
                            <td>Phys Damage Cents per Mile:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['physical_damage_cents_per_mile']}</td>
                          </tr>
                          <tr>
                            <td>Liability Uninsured Gig Mls Uplift:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['liability_uninsured_gig_miles_uplift']}</td>
                          </tr>
                          <tr>
                            <td>Phys Damage Uninsured Gig Mls Uplift:  </td>
                            <td style={{paddingLeft: '18px'}}>{policy['rows'][0]['physical_damage_uninsured_gig_miles_uplift']}</td>
                          </tr>
                        </table>
                      </View>
                      :
                      <View>
                        <Heading level={4}>Policy Not Found</Heading>
                      </View>
                  }
                </Flex>
              </Flex>
          }
          {policy === false ? undefined:
            policy['rows'] === false ? undefined:
            typeof(policy['rows']) === 'undefined' ?  undefined:
            policy['rows'][0] === false ? undefined:
            <Flex direction="column">
              <Divider />
              {
                displaySuperAdministrativeFunctions===false?undefined:
                showDataPacket ?
                  <Flex direction="column">
                    <Heading level={2}>Data Packet</Heading>
                    <pre id="json"><p>{JSON.stringify(policy,null, 4)}</p></pre>
                    <Button onClick={() => updateShowDataPacket(false)}>
                      Hide Data Packet
                    </Button>
                  </Flex>
                : 
                  <Button onClick={() => updateShowDataPacket(true)}>
                    Policy Data Packet
                  </Button>
              }
              <br/><br/><br/><br/>
            </Flex>
          }
      </View>
    </Flex>
  );
}